import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { loadPeriodos } from '../../store/actions/Periodos';

import { 
    getDataDaProvaFormatado,
    isPeriodoConfirmacao,
    getPeriodoDeConfirmacaoFormatado,
} from '../../helper/ContextHelper';

import Grid from '@material-ui/core/Grid';
import Alert from '@material-ui/lab/Alert';
import Typography from '@material-ui/core/Typography';
import { Paper } from '@material-ui/core';

import CandidatoService from '../../services/Candidato';

import Title from '../../components/Title/Title';
import Toast from '../../components/Toast/Toast';

import LocalProva from '../../forms/LocalProva/LocalProva';

import ButtonsForm from '../../forms/Buttons/ButtonsForm';

import keycloak, { handleLogin } from '../../security/keycloak';

import { filterPersistence } from '../../helper/ParseStateHelper';

import Layout from '../../layouts/private/Private';
import Loading from '../../components/Loading/Loading';

export class FormConfirmacao extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: this.props.match.params.id,
      dataConfirmacao: '',
      municipioNomeOriginal: '',
      ufOriginal: '',
      history: {
        path: null,
        state: null,
      },
      loading: false,
      loadingButtonSave: false,
      naoPodeFazerAlteracao: false,
    }
  }

  setToast = t => this.Toast = t;  
  setLocalProva = e => this.LocalProva = e;  

  loadData = async () => {
    try {
      await this.props.loadPeriodos();
      const id = this.props.match.params.id;

      this.setState({
        loading: true,
        history: filterPersistence(this.props.location)
      });

      const res = await CandidatoService.find(id);
      const candidato = res.data;

      const uf = candidato.localProvaFinal ? candidato.localProvaFinal.uf.id : candidato.localProvaOriginal.uf.id;
      const municipioCodigo = candidato.localProvaFinal ? candidato.localProvaFinal.codigo : candidato.localProvaOriginal.codigo;

      const ufOriginal = candidato.localProvaOriginal.uf.id;
      const municipioNomeOriginal = candidato.localProvaOriginal.nome;
      
      this.setState({
        dataConfirmacao: candidato.dataConfirmacaoLocalProvaFinal,
        municipioNomeOriginal: municipioNomeOriginal,
        ufOriginal: ufOriginal,
        naoPodeFazerAlteracao: candidato.dataFinalizacaoInscricao == null,
      });

      this.LocalProva.findCities(uf, municipioCodigo);
      this.LocalProva.setState({
        localProva: {
          municipio: municipioCodigo,
          uf: uf,
        }
      });

    } catch (error) {
      this.handleError();
    } finally {
      this.setState({ loading: false });
    }
  }

  handleSubmit = async () => {
    this.setState({ loadingButtonSave: true });

    const formLocalProvaIsValid = this.LocalProva.isValid();

    if (!formLocalProvaIsValid ) {
      this.setState({ loadingButtonSave: false });
      this.Toast.setState({
        message: {
          message: `Houve um problema de validação nos dados informados no formulário. Revise as informações preenchidas e tente novamente.`,
          type: "warning",
          open: true
        }
      })
      return
    }

    const localProva ={
      municipio: this.LocalProva.state.localProva.municipio,
    } 

    CandidatoService.confirmarLocalProva(this.state.id, localProva)
      .then(res => {
        this.Toast.setState({
          message: {
            message: `Município confirmado com sucesso.`,
            type: "success",
            open: true
          }
        })

        this.loadData();

        setTimeout(() => !keycloak.authenticated ? handleLogin(`${process.env.REACT_APP_PUBLIC_URL}/admin/inicial`) : this.handleBack(), 2000);
      })
      .catch(err => {
        this.Toast.setState({
          message: {
            message: `Ocorreu um Problema ao Confirmar o Município de Realização da Prova`,
            type: "error",
            open: true
          }
        })
      })
      .finally(() => this.setState({ loadingButtonSave: false }));
  }

  handleError = (message = "Ocorreu um Problema ao Confirmar o Município de Realização da Prova") => {
    this.Toast.setState({
      message: {
        message: message,
        type: "error",
        open: true
      }
    })
  }

  handleBack = () => {
    if (this.state.history && this.state.history.path) {
      this.props.history.push({
        pathname: `${this.state.history.path}`,
        state: {
          history: {
            state: this.state.history.state
          }
        }
      });
    } else {
      this.props.history.goBack();
    }
  }

  componentDidMount() {
    this.loadData();
  }

  render() {
    const page = `Confirmação do Município para Realização da Prova`;
    
    const dataProva = getDataDaProvaFormatado(this.props.contexts);
    const isPodeEditarDados = isPeriodoConfirmacao(this.props.contexts) && !this.state.naoPodeFazerAlteracao;
    const periodoConfirmacao = getPeriodoDeConfirmacaoFormatado(this.props.contexts);

    return (
      <Layout>
        <Toast parentRef={this.setToast} />
        <Title>{page}</Title>

        <Loading show={this.state.loading} />
        
        <Grid container spacing={3} style={{ display: this.state.loading ? 'none' : 'flex' }}>
          <Grid item sm={12} lg={12}>
            <Alert severity="info">
              Preencha <b>TODOS</b> os campos abaixo para confirmar o município de realização da prova.
            </Alert>
          </Grid>
        </Grid>

        <Paper elevation={3} style={{ padding: 24, marginTop: 24 }}>
          <Grid item sm={12} lg={9}>
            <Typography variant="body2" style={{ fontSize: 14 }}>Na etapa de inscrição, o município {" "} <b>{this.state.municipioNomeOriginal} - {this.state.ufOriginal}</b>{" "}foi sua escolha para a realização da prova.
              <br />
              <br />
              Realize a sua confirmação, ou se necessário, informe outro município para a realização da prova 
              caso no dia da prova  <b>{dataProva && `(${dataProva})`}</b>  você não esteja disponível no município informado anteriormente.
              </Typography>
          </Grid>
          <br />
          <Grid container spacing={3}>
            <Grid item sm={12} lg={12}>
              {this.state.dataConfirmacao ? (
                <Alert severity="success">
                  O município selecionado já teve sua confirmação realizada em <b>{this.state.dataConfirmacao}</b>. {isPodeEditarDados && <>{' '} Você poderá alterar o município confirmado no período de <b>{periodoConfirmacao}</b>.</>}  
                </Alert>
              ) : (
                <Alert severity="warning">
                  Você ainda não realizou a confirmação do município para a prova.
                </Alert>
              )}
            </Grid>
          </Grid>

          <LocalProva parentRef={this.setLocalProva } disabled={!isPodeEditarDados} />
        </Paper>

        <ButtonsForm
          onClick={this.handleSubmit}
          onBack={this.handleBack}
          loading={this.state.loadingButtonSave}
          name={"Salvar"}
          nameOnBack={"Voltar"}
          idFocus={`saveButton`}
          saveDisabled={!isPodeEditarDados}
        />
      </Layout>
    )
  }
}

const mapStateToProps = state => ({ contexts: state.periodos });
const mapDispatchToProps = dispatch => (bindActionCreators({ loadPeriodos }, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(FormConfirmacao));